import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,
  MATIC = 137,
  MATIC_TESTNET = 80001,
  FANTOM = 250,
  FANTOM_TESTNET = 4002,
  XDAI = 100,
  BSC = 56,
  BSC_TESTNET = 97,
  ARBITRUM = 79377087078960,
  MOONBASE = 1287,
  AVALANCHE = 43114,
  FUJI = 43113,
  HECO = 128,
  HECO_TESTNET = 256,
  HARMONY = 1666600000,
  HARMONY_TESTNET = 1666700000,
  OKEX = 66,
  OKEX_TESTNET = 65
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const INIT_CODE_HASH: string = '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303'

export const FACTORY_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.ROPSTEN]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.RINKEBY]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.GÖRLI]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.KOVAN]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.FANTOM]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.MATIC_TESTNET]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.XDAI]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.BSC]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.BSC_TESTNET]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '0x2Ce3F07dD4c62b56a502E223A7cBE38b1d77A1b5',
  [ChainId.AVALANCHE]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.FUJI]: '0xd00ae08403B9bbb9124bB305C09058E32C39A48c',
  [ChainId.HECO]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.HECO_TESTNET]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.HARMONY]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.HARMONY_TESTNET]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.OKEX]: '0x928aa8d032281fcbbb742392f8f307f564715474',
  [ChainId.OKEX_TESTNET]: '0x928aa8d032281fcbbb742392f8f307f564715474'
}

export const ROUTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.RINKEBY]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.ROPSTEN]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.GÖRLI]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.KOVAN]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.FANTOM]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.MATIC_TESTNET]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.XDAI]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.BSC]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.BSC_TESTNET]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '0xeB5c2BB5E83B51d83F3534Ae21E84336B8B376ef',
  [ChainId.AVALANCHE]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.FUJI]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.HECO]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.HECO_TESTNET]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.HARMONY]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.HARMONY_TESTNET]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.OKEX]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5',
  [ChainId.OKEX_TESTNET]: '0x788DEB2415835ad86de7796b5f2af4d1dE397eC5'
}

export const SUSHI_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x39c3699ab94179b061bc84db29b9f39df8121c9b',
  [ChainId.ROPSTEN]: '0x39c3699ab94179b061bc84db29b9f39df8121c9b',
  [ChainId.RINKEBY]: '0x39c3699ab94179b061bc84db29b9f39df8121c9b',
  [ChainId.GÖRLI]: '0x39c3699ab94179b061bc84db29b9f39df8121c9b',
  [ChainId.KOVAN]: '0x39c3699ab94179b061bc84db29b9f39df8121c9b',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const MASTERCHEF_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x3c9d0c5ba35c6e97aa898d543ac4318921043997',
  [ChainId.ROPSTEN]: '0x3c9d0c5ba35c6e97aa898d543ac4318921043997',
  [ChainId.RINKEBY]: '0x3c9d0c5ba35c6e97aa898d543ac4318921043997',
  [ChainId.GÖRLI]: '0x3c9d0c5ba35c6e97aa898d543ac4318921043997',
  [ChainId.KOVAN]: '0x3c9d0c5ba35c6e97aa898d543ac4318921043997',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const BAR_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xb8479e0e80045cace5f80fb8e34c70df91b1e21c',
  [ChainId.ROPSTEN]: '0xb8479e0e80045cace5f80fb8e34c70df91b1e21c',
  [ChainId.RINKEBY]: '0xb8479e0e80045cace5f80fb8e34c70df91b1e21c',
  [ChainId.GÖRLI]: '0xb8479e0e80045cace5f80fb8e34c70df91b1e21c',
  [ChainId.KOVAN]: '0xb8479e0e80045cace5f80fb8e34c70df91b1e21c',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const MAKER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xe636cdc96d41978edf3eb6f774d727fa22d94762',
  [ChainId.ROPSTEN]: '0xe636cdc96d41978edf3eb6f774d727fa22d94762',
  [ChainId.RINKEBY]: '0xe636cdc96d41978edf3eb6f774d727fa22d94762',
  [ChainId.GÖRLI]: '0xe636cdc96d41978edf3eb6f774d727fa22d94762',
  [ChainId.KOVAN]: '0xe636cdc96d41978edf3eb6f774d727fa22d94762',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const TIMELOCK_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x9a8541Ddf3a932a9A922B607e9CF7301f1d47bD1',
  [ChainId.ROPSTEN]: '',
  [ChainId.RINKEBY]: '',
  [ChainId.GÖRLI]: '',
  [ChainId.KOVAN]: '',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
